export default "__VITE_ASSET__CzPpIPep__"